import './Carousel.css'
import { useRef } from 'react'

export default function Carousel({ children, label = 'items' }) {
  const ref = useRef(null)
  const go = d => ref.current.scrollBy({ left: d * ref.current.clientWidth * 0.85, behavior: 'smooth' })
  return (
    <div className="car">
      <button className="car__btn car__btn--l" onClick={() => go(-1)} aria-label={`Previous ${label}`}>‹</button>
      <div className="car__track" ref={ref}>{children}</div>
      <button className="car__btn car__btn--r" onClick={() => go(1)} aria-label={`Next ${label}`}>›</button>
    </div>
  )
}